<template>
    <div class="displayTextContainer">
        <div class="flexrow">
            <p v-if="showLabel"><b>Display Text</b></p> 
            <div class="replacementStringContainer">               
                <select v-model="selectedOption">
                    <option value='' selected>Choose Replacement String</option>
                    <option v-for="(replacementString, index) in replacementStrings" v-bind:key="index" v-bind:value="replacementString">{{replacementString}}</option>
                </select>
                <button @click="addString" style="margin-left: 20px">Add</button>
            </div>
        </div>
        <textarea v-model="internalDisplayText" :ref="'displayTextArea'" @keyup="onKeyup"  @blur="onBlur" :disabled="disabled" :style="calcStyle"></textarea>
    </div>
</template>
<script>
import { useAttributeStore } from '@/shared/attributeStore';

export default {
    name: 'DisplayText',
    props: {
        object: {
            type: Object
        },
        displayText: {
            type: String
        },
        onChanged: {
            type: Function
        },
        textPropertyName: {
            type: String,
            default: "displayText"
        },
        disabled: {
            type: Boolean,
            default: false
        },
        showLabel: {
            type: Boolean,
            default: true
        },
        width: {
            type: String,
            value: ""
        }
    },
    data: function() {
        return {
            internalDisplayText: '' ,
            replacementStrings: [],
            selectedOption: '',
            index: 0
        };
    },
    async mounted() {
        const store = useAttributeStore();
        this.replacementStrings = await store.getAttributes();
        this.internalDisplayText = this.displayText;
    },
    computed: {
        calcStyle () {
            if(this.width != "")
                return "width: " + this.width;
            else 
                return "";
        }
    },
    methods: {
        onBlur: async function() {
            if(this.onChanged) {
                this.onChanged(this.object, this.internalDisplayText, this.textPropertyName);
            }
        },
        onKeyup: async function() {
            const textarea = this.$refs['displayTextArea'];
            this.index = textarea.selectionStart;
        },
        compareValues: function(key, order = 'asc') {
            return function innerSort(a, b) {
                const varA = (typeof a[key] === 'string')
                    ? a[key].toUpperCase() : a[key];
                const varB = (typeof b[key] === 'string')
                    ? b[key].toUpperCase() : b[key];

                let comparison = 0;
                if (varA > varB) {
                    comparison = 1;
                } 
                else if (varA < varB) {
                    comparison = -1;
                }

                return ( (order === 'desc') ? (comparison * -1) : comparison );
            };
        },
        addString() {        
            const textarea = this.$refs['displayTextArea'];
            if(this.internalDisplayText)
               this.internalDisplayText = `${this.internalDisplayText.substring(0,this.index)}${this.selectedOption}${this.internalDisplayText.substring(this.index)}`;
            else 
                this.internalDisplayText = this.selectedOption;
            textarea.focus();
            this.selectedOption = '';
        }
    }
}
</script>

<style scoped>    
    .displayTextContainer button {
        margin: 0 20px 10px 0;
        padding: 1px 3px;
        background-color: #FFD831;
        border: 1px solid #000000;
        border-radius: 5px;
        cursor: pointer;
        font-size: 16px;
    }

    .flexrow {
        display: flex; 
        flex-direction: row; 
        width: 100%;
    }

    .replacementStringContainer {
        margin: auto 0px; 
        padding-left: 30px;
    }

     .displayTextContainer textarea {
        width: 100%;
        min-height: 100px;
        box-sizing: border-box;
    }

</style>
